import TAGGED from "../modules/tagged_content"
import GET_ARTICLES from "../plugins/getArticles"

const [ w, d, content ] = [ window, document, 'recommend' ]

const init = () => {
  $('.contents .wrapLink','.element_list').each( (i,obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true: false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj? catObj.innerText : ''
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText
    let $item = $(`
      <a href="${href}" class="recommend-item">
        <figure class="recommend-item__img">
          <div class="recommend-item__img-cover"><img src="${thumb}" alt="${title}" width=""></div>
        </figure>
        <div class="recommend-item__body">
          ${is_new ? '<span class="new">NEW</span>': ''}
          ${cat ? `<span class="cat">${cat}</span>`: ''}
          <h4 class="name">${title}</h4>
          <p class="desc">${desc}</p>
        </div>
      </a>`)
    $(obj).replaceWith( $item )
  })

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    
    let catname = d.querySelector('.title .catetitle').innerText
    let title = d.querySelector('.hs_entrytitle').innerText
    let $detailHead = $(`
      <div class="recommend-detailHead">
        <span class="recommend-detailHead__catname button button-secondary button-xsmall">${catname}</span>
        <h3 class="recommend-detail-title">${title}</h3>
      </div>
    `)
    $('.element_detail .hs_entrytitle').remove()
    $('.element_detail > .title').replaceWith( $detailHead )

  }
}

export default function RECOMMEND () {  // 一覧ページのテンプレート(Vue template)
  const itemTemplate = `
    <div id="main" class="column-3-4">
      <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
        <a class="${content}-item" :href="article.href" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
              <img :src="article.thumb" width="200">
            </div>
          </figure>
          <div class="${content}-item__body">
            <span class="new" v-if="article.is_new">NEW</span>
            <span class="cat" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span>
            <h4 class="name">
              {{ article.title | truncate }}
            </h4>
            <p class="desc">{{ article.desc | truncate( 40 ) }}</p>
          </div>
        </a>
      </transition-group>
      <pagination
        v-if="totalPage > 1"
        :paged="paged"
        :total-page="totalPage"
        :total-item="totalItem"
        :item-count="pagedArticles.length"
        :prevText="'Prev'"
        :nextText="'Next'"
        @change="pageChange"
      />
    </div>
  `

  // カテゴリ一覧ページにて、記事ごとの要素置き換え
  const replaceItemTemplate = item => `
    <a class="${content}-item" href="${item.href}">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url( ${item.thumb} )">
          <img src="${item.thumb}" width="200">
        </div>
      </figure>
      <div class="${content}-item__body">
        <div class="${content}-item__title">
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <h4 class="name">
            ${item.title.str_truncate( 20 )}
          </h4>
          <p class="desc">
            ${item.desc.str_truncate( 40 )}
          </p>
        </div>
      </div>
    </a>
  `

  // 関連記事のテンプレート(Vue template)
  const relatedItemTemplate = `
    <div class="${content}-related">
      <div data-plugin="related_articles" class="${content}-list" v-if="relatedArticles.length >= 1">
        <a class="${content}-item" :href="article.href" v-for="article in relatedArticles" :key="article.id">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'"><img :src="article.thumb" width="200"></div>
          </figure>
          <div class="${content}-item__body">
            <span class="new" v-if="article.is_new">NEW</span>
            <span class="cat" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span>
            <h4 class="name">{{ article.title | truncate  }}</h4>
            <p class="desc">{{ article.desc | truncate( 40 )  }}</p>
          </div>
        </a>
      </div>
    </div>
  `

  TAGGED({
    perpage: 20,
    related: true,
    taglist_disp_list: true, // head / foot / both
    taglist_disp_detail: 'foot', // head / foot / both
    taglist_minimumTagAmount : 12, // タグの最低表示数
    taglist_hideUselessTags : 4, // 最低使用回数
    itemTemplate,
    replaceItemTemplate,
    relatedItemTemplate,
    callback() {
      // フリーブロックを追加する
      // $.getFreeBlock({xml:'b_content_content1.xml'}).then( blocks => {
      //   let $container = $('#container','.is--list')
      //   if( blocks.mainhead && blocks.mainhead.length ) $container.prepend( $(blocks.mainhead) )
      //   if( blocks.mainfoot && blocks.mainfoot.length ) $container.append( $(blocks.mainfoot) )
      // })
    }
  })
  $( init )
}